<!--<ng-template >-->
  <p-progressBar   mode="indeterminate"  *ngIf="global.progressBar"
                   [style]="{'height': '6px','position': 'fixed','width': '100%','border-radius':'0px'}"></p-progressBar>
  <p-toast position="bottom-left" [hideTransitionOptions]="'0ms'"   ></p-toast>
  <p-confirmDialog [style]="{width: '420px '}" [baseZIndex]="10000"></p-confirmDialog>
  <div class="{{getDirection() =='rtl'?'base-rtl':'base-ltr'}} mdiv ui-fluid  " >
    <div class="topTemplate">
      <div class="left">
        <i style="margin-right: 10px" (click)="goToOverView()" i18n-pTooltip="@@Show" pTooltip="Show"  class="pi pi-eye"></i>
        <i style="margin-right: 10px" (click)="logout()" i18n-pTooltip="@@Logout" pTooltip="Logout"  class="ico icon-exit"></i>
      </div>
    </div>
    <div class="center"
         [@routeAnimations]="outlet.isActivated ? outlet.activatedRoute : '' && outlet.activatedRouteData
         && outlet.activatedRouteData['animation']" >
      <div class="ui-g-12"  >
        <router-outlet  #outlet="outlet" ></router-outlet>
      </div>
    </div>
  </div>
<!--</ng-template>-->
